module.exports = __webpack_public_path__ + "img/question_bg.297e0bcf.png";